const messages: Record<string, string> = {
  SESSION_FULL: 'Der Termin ist leider bereits ausgebucht.',
  ALREADY_BOOKED: 'Sie sind für den gewählten Termin bereits registriert.',
  TOKEN_INVALID: 'Der Link ist ungültig oder wurde bereits verwendet.',
  TOKEN_EXPIRED: 'Der Link ist abgelaufen. Bitte buche den Termin erneut.',
  SESSION_NOT_FOUND: 'Der Termin wurde nicht gefunden.',
  SESSION_NOT_BOOKABLE: 'Der Termin ist nicht mehr buchbar.',
  EMAIL_REQUIRED: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  NAME_REQUIRED: 'Bitte gib deinen vollständigen Namen ein.',
  USER_NOT_FOUND: 'Kein Auth-User mit dieser E-Mail gefunden.',
  UNAUTHORIZED: 'Du bist für diese Aktion nicht berechtigt.',
  TRAINER_REQUIRED: 'Bitte einen Trainer auswählen.',
  TRAINER_INVALID: 'Der ausgewählte Trainer ist ungültig oder inaktiv.',
  EMAIL_ALREADY_REGISTERED: 'Für diese E-Mail existiert bereits ein Benutzerkonto.',
  ROLE_INVALID: 'Die ausgewählte Rolle ist ungültig.',
  CREATE_MODE_INVALID: 'Der Erstellmodus ist ungültig.',
  OPERATION_INVALID: 'Die angeforderte Aktion ist ungültig.',
  PASSWORD_TOO_SHORT: 'Das Initialpasswort ist zu kurz (mindestens 6 Zeichen).',
  USER_CREATION_FAILED: 'Der Benutzer konnte nicht angelegt werden.',
  USER_UPDATE_FAILED: 'Der Benutzer konnte nicht aktualisiert werden.',
  USER_ID_REQUIRED: 'Die Benutzer-ID fehlt.',
  STATUS_INVALID: 'Der Aktivstatus ist ungültig.',
  INVALID_JSON: 'Ungültige Anfrage gesendet.',
  METHOD_NOT_ALLOWED: 'Diese Aktion ist nicht erlaubt.',
  COURSE_REQUIRED: 'Bitte zuerst einen Kurs auswählen.',
  COURSE_DELETE_FAILED: 'Der Kurs konnte nicht gelöscht oder deaktiviert werden.',
  START_REQUIRED: 'Bitte eine Startzeit auswählen.',
  MAX_PARTICIPANTS_INVALID: 'Bitte eine gültige maximale Teilnehmerzahl eingeben.',
  MIN_PARTICIPANTS_INVALID:
    'Bitte eine gültige Mindest-Teilnehmerzahl eingeben oder das Feld leer lassen.',
  MIN_PARTICIPANTS_EXCEEDS_MAX:
    'Die Mindest-Teilnehmerzahl darf die maximale Teilnehmerzahl nicht übersteigen.',
  SESSION_HAS_BOOKINGS: 'Der Termin kann nicht gelöscht werden, da bereits Buchungen existieren.',
  NOT_FOUND: 'Eintrag wurde nicht gefunden.',
  PROFILE_NOT_FOUND: 'Für diesen Account ist kein Admin-Profil hinterlegt.',
  ACCOUNT_INACTIVE: 'Dein Konto ist deaktiviert. Bitte kontaktiere einen Admin.',
  NO_ACTIVE_SUBSCRIPTION: 'Du hast kein aktives Abo. Bitte wähle ein Kurspaket.',
  NO_CREDITS_REMAINING: 'Dein Guthaben ist aufgebraucht. Bitte lade Kursguthaben nach.',
  WEEKLY_LIMIT_REACHED: 'Du hast das Wochenlimit deines Monatsabos erreicht.',
  SESSION_CANCELLED: 'Dieser Termin wurde storniert.',
  SESSION_IN_PAST: 'Dieser Kurs liegt in der Vergangenheit und kann nicht mehr gebucht werden.',
  REGISTRATION_DEADLINE_PASSED: 'Die Anmeldefrist für diesen Kurs ist abgelaufen.',
  INVALID_PACKAGE: 'Das gewählte Paket ist nicht verfügbar.',
  PACKAGE_STRIPE_PRICE_MISSING: 'Für dieses Paket ist noch kein Stripe-Preis hinterlegt.',
  CHECKOUT_SESSION_CREATE_FAILED: 'Checkout konnte nicht gestartet werden. Bitte versuche es erneut.',
  CUSTOMER_PORTAL_CREATE_FAILED: 'Das Kundenportal konnte nicht geöffnet werden.',
  INVOICE_DOWNLOAD_FAILED: 'Die Rechnung konnte nicht heruntergeladen werden.',
  INVOICE_NOT_FOUND: 'Die Rechnung wurde nicht gefunden.',
  INVOICE_PDF_UNAVAILABLE: 'Für diese Rechnung ist aktuell kein Download verfügbar.',
  INVOICE_DOCUMENT_UNAVAILABLE: 'Für diesen Eintrag ist kein Rechnungsdokument verfügbar.',
  PLAN_CHANGE_REQUIRES_PORTAL:
    'Der Wechsel zwischen Monatsabos erfolgt über das Kundenportal zum Periodenende.',
  ALREADY_ACTIVE_PACKAGE: 'Dieses Paket ist bereits aktiv.',
  SUBSCRIPTION_NOT_ACTIVE:
    'Dein Monatsabo ist aktuell nicht zahlungsaktiv. Bitte prüfe deine Zahlungsmethode im Kundenportal.',
  NOT_AUTHENTICATED: 'Bitte melde dich erneut an.',
  REGISTRATION_DEADLINE_AFTER_START: 'Die Anmeldefrist darf nicht nach dem Kursbeginn liegen.',
  BOOKING_NOT_FOUND: 'Die Buchung wurde nicht gefunden oder gehört nicht zu deinem Konto.',
  CANCELLATION_DEADLINE_PASSED: 'Die Stornierungsfrist ist abgelaufen.',
  CREDIT_DELTA_INVALID: 'Bitte gib eine gültige Anzahl an Credits an.',
  CREDIT_REASON_REQUIRED: 'Bitte gib einen Grund für die manuelle Guthabenänderung an.',
  PAYMENT_AMOUNT_INVALID: 'Bitte gib einen gültigen bezahlten Betrag an.',
  PAYMENT_AMOUNT_ONLY_FOR_TOPUP:
    'Ein bezahlter Betrag kann nur bei manuellen Aufbuchungen hinterlegt werden.',
  PAID_TOPUP_REQUIRES_STRIPE_INVOICE:
    'Bezahlte manuelle Aufbuchungen müssen über die Stripe-Rechnung erfolgen.',
  OPERATION_KEY_REQUIRED:
    'Für diese manuelle Aufbuchung fehlt der eindeutige Vorgangsschlüssel.',
  PAYMENT_ENTRY_CREATE_FAILED:
    'Die Zahlung konnte nicht vollständig gespeichert werden. Bitte prüfe Stripe und versuche es erneut.',
  VOUCHER_CODE_REQUIRED: 'Bitte gib einen Gutschein-Code ein.',
  VOUCHER_NOT_FOUND: 'Dieser Gutschein-Code ist ungültig.',
  VOUCHER_INACTIVE: 'Dieser Gutschein-Code ist nicht mehr aktiv.',
  VOUCHER_EXHAUSTED: 'Dieser Gutschein-Code wurde bereits vollständig eingelöst.',
  VOUCHER_ALREADY_REDEEMED: 'Du hast diesen Gutschein-Code bereits eingelöst.',
  VOUCHER_CODE_INVALID:
    'Bitte gib einen gültigen Gutschein-Code ein. Erlaubt sind Buchstaben, Zahlen und Bindestriche.',
  VOUCHER_CODE_DUPLICATE: 'Dieser Gutschein-Code existiert bereits.',
  VOUCHER_CREDITS_INVALID: 'Bitte gib eine gültige Anzahl an Credits für den Gutschein an.',
  VOUCHER_REDEMPTIONS_INVALID:
    'Bitte gib eine gültige maximale Anzahl an Einlösungen für den Gutschein an.',
  VOUCHER_REDEMPTIONS_BELOW_USAGE:
    'Die maximale Anzahl darf nicht unter den bereits erfolgten Einlösungen liegen.',
  VOUCHER_REDEEMED_FIELDS_LOCKED:
    'Bei bereits eingelösten Gutscheinen kann nur die maximale Anzahl an Einlösungen geändert werden.',
  VOUCHER_DELETE_REDEEMED:
    'Dieser Gutschein wurde bereits eingelöst und kann nicht gelöscht werden.',
  VOUCHER_CODE_GENERATION_FAILED:
    'Der Gutschein-Code konnte nicht erzeugt werden. Bitte versuche es erneut.',
  SUPABASE_ENV_MISSING: 'Die Server-Konfiguration ist unvollständig.',
  STRIPE_ENV_MISSING: 'Die Stripe-Konfiguration ist unvollständig.',
  STRIPE_CUSTOMER_REQUIRED: 'Der Stripe-Kunde für diese Aufbuchung fehlt.',
  STRIPE_INVOICE_REQUIRED: 'Die Stripe-Rechnung für diese Aufbuchung fehlt.',
  PASSWORDS_DO_NOT_MATCH: 'Die Passwörter stimmen nicht überein.',
  INVALID_CANCELLATION_HOURS: 'Bitte gib eine gültige Stundenzahl ab 0 ein.',
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message in messages) {
    return messages[error.message]
  }

  if (error instanceof Error) {
    const lower = error.message.toLowerCase()
    if (lower.includes('captcha')) {
      return 'Sicherheitsprüfung fehlgeschlagen. Bitte löse das CAPTCHA erneut.'
    }
    return error.message
  }

  return 'Unerwarteter Fehler. Bitte erneut versuchen.'
}
